if (!customElements.get("questionnaire-section")) {
  class QuestionnaireSection extends HTMLElement {
    constructor() {
      super();
      this.history = [];
    }

    connectedCallback() {
      this.addEventListener("change", this.handleChange.bind(this));
      this.addEventListener("click", this.handleNext.bind(this));
      this.addEventListener("click", this.handlePrev.bind(this));
      this.updateButtonsState();
    }

    // fetch next question
    // render next question
    // update button state
    // get selected option
    handlePrev(event) {
      this.prevButton = this.querySelector("[data-questionnaire-prev]");
      if (event.target !== this.prevButton) return;

      if (!this.history.length) return;

      const previous = this.history.pop();
      this.innerHTML = previous.html;
      this.updateButtonsState();

      // Automatically scroll to the top of the questionnaire
      this.scrollIntoView({ behavior: "smooth", block: "start" });

      // Restore previous selection if we have it
      if (previous.selectedValue) {
        const candidate = this.querySelector(
          `input[value="${CSS.escape(previous.selectedValue)}"]`,
        );
        if (candidate) {
          candidate.checked = true;
          if (this.nextButton) this.nextButton.disabled = false;
        }
      } else {
        // If any input is checked in restored markup, enable next
        const checked = this.querySelector("input:checked");
        if (checked && this.nextButton) this.nextButton.disabled = false;
      }
    }

    handleNext(event) {
      this.nextButton = this.querySelector("[data-questionnaire-next]");

      if (event.target !== this.nextButton) return;

      const selectedOption = this.querySelector("input:checked");
      if (!selectedOption) return;

      this.nextButton.classList.add("loading");
      this.nextButton.disabled = true;

      // Save current state to history so we can navigate back
      this.history.push({
        html: this.innerHTML,
        selectedValue: selectedOption ? selectedOption.value : null,
      });

      const nextQuestionUrl = selectedOption.value;

      this.fetchNextQuestion(nextQuestionUrl).then((data) => {
        this.renderNextQuestion(data);
      });
    }

    handleChange(event) {
      const selectedOption = event.target;
      if (!selectedOption.checked) return;

      this.nextButton.disabled = false;
    }

    async fetchNextQuestion(url) {
      const response = await fetch(url);
      const data = await response.text();
      return data;
    }

    renderNextQuestion(data) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;
      const nextQuestion = tempDiv.querySelector("questionnaire-question");
      this.innerHTML = nextQuestion.innerHTML;

      tempDiv.remove();

      this.updateButtonsState();
    }

    updateButtonsState() {
      this.nextButton = this.querySelector("[data-questionnaire-next]");
      this.prevButton = this.querySelector("[data-questionnaire-prev]");

      if (this.prevButton) {
        this.prevButton.disabled = this.history.length === 0;
      }

      // Remove loading state from any lingering reference
      if (this.nextButton) {
        this.nextButton.classList.remove("loading");
      }
    }
  }
  customElements.define("questionnaire-section", QuestionnaireSection);
}
